import React from 'react';
import { useSelector } from 'react-redux';
import { selectReportsIds } from './reportsSlice';
import ReportRow from './ReportRow';
import EmptyReport from './EmptyReport';

const ReportItemCollections = () => {
  const reportsIds = useSelector(selectReportsIds);

  if (reportsIds.length === 0) {
    return EmptyReport();
  }
  return (
    <div className="px-4 sm:px-2 lg:py-4">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">
            Wallet History
          </h1>
        </div>
      </div>
      <div className="-mx-4 mt-8 overflow-hidden  ring-opacity-5 sm:-mx-6 md:mx-0 md:rounded-lg">
        <table className="min-w-full divide-y divide-gray-50">
          <thead className="bg-white">
            <tr>
              <th
                scope="col"
                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
              >
                Date
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
              >
                Balance Before
              </th>
              <th
                scope="col"
                className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
              >
                Balance After
              </th>
              <th
                scope="col"
                className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
              >
                Amount Change
              </th>
              <th
                scope="col"
                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
              >
                Credit
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50 bg-white">
            {reportsIds.map((id) => (
              <ReportRow key={id} id={id} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportItemCollections;
